// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_3-CnU9QDXXylvS__amaNuX","subHeader":"_2IXtzsBs43JlXY6woJ-s1g"};